const state = {
  embalagemMaster: false
}

const getters = {
  getEmbalagemMaster(state){
    return state.embalagemMaster
  }
}

const mutations = {
  setEmbalagemMaster(state, valor){
    state.embalagemMaster = valor
  }
}

const actions = {
  setEmbalagemMaster: ({ commit }, valor) => {
    commit("setEmbalagemMaster", valor)
  }
}

export default { namespaced: true, state, mutations, getters, actions }
